export const getGuestLeadersColumnDefs = () => [
  {
    headerName: 'Cédula',
    field: 'Guest.identification',
    width: 140,
    cellRenderer: (params) => params.data?.Guest?.identification || '',
  },
  {
    headerName: 'Nombre',
    field: 'Guest.name',
    width: 180,
    cellRenderer: (params) => params.data?.Guest?.name || '',
  },
  {
    headerName: 'Apellido',
    field: 'Guest.lastName',
    width: 180,
    cellRenderer: (params) => params.data?.Guest?.lastName || '',
  },
  {
    headerName: 'Celular',
    field: 'Guest.phone',
    width: 140,
    cellRenderer: (params) => params.data?.Guest?.phone || '',
  },
  {
    headerName: 'Nombre Líder',
    field: 'leaderFullName',
    width: 200,
    cellRenderer: (params) => params.data?.leaderFullName || '',
  },
  {
    headerName: 'Celular Líder',
    field: 'leaderPhone',
    width: 150,
    cellRenderer: (params) => params.data?.leaderPhone || '',
  },
];

const GuestLeadersRow = (props) => {
  const { guestLeader } = props;
  const { Guest, leaderFullName, leaderPhone } = guestLeader;
  const { name, lastName, phone, identification } = Guest;

  return (
    <tr>
      <td>
        <p style={{ margin: '0' }}>{identification}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{name}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{lastName}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{phone}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{leaderFullName}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{leaderPhone}</p>
      </td>
    </tr>
  );
};

export default GuestLeadersRow;
